import React from "react";

export default function GoldLoanOffers({ setCurrentStep, setSelectedOffer }) {
  // Function to save the selected lender and move to the success page
  const handleSelectGoldOffer = (lenderName) => {
    setSelectedOffer({ lender_name: lenderName });
    setCurrentStep(5);
  };

  return (
    <div className="w-full max-w-[400px] mx-auto bg-[#f8f9fa] min-h-[100dvh] pb-8 font-atkinson relative overflow-hidden flex flex-col">
      <div className="px-5 pt-8">
        {/* Header Title */}
        <h1 className="text-[26px] font-bold text-center leading-tight text-[#1b1b1b]">
          <span className="text-[#FF7A00]">Sorry!</span> You are not eligible
        </h1>
        <p className="text-center text-[#6b6b6b] text-[13px] mt-2 mb-4 px-2">
          You don't currently qualify for Personal Loan offers based on our partner lenders' eligibility criteria.
        </p>

        {/* Good News Box */}
        <div className="bg-[#FFFDF5] border border-[#EEDB9F] rounded-[14px] p-4 flex items-start gap-4 shadow-sm">
          <div className="text-[32px] leading-none mt-1">🪙</div>
          <div>
            <h3 className="font-bold text-[14px] text-[#1b1b1b]">But here's some good news!</h3>
            <p className="text-[12px] text-[#6b6b6b] mt-1 leading-snug">
              You qualify for <span className="text-[#C69A27] font-semibold">Gold Loan offers</span> from 2 trusted lenders. Your offers are ready to compare with faster approval chances.
            </p>
          </div>
        </div>

        {/* Timer Badge */}
        <div className="bg-[#EBF7EF] text-[#3F8259] text-[12px] font-medium flex items-center justify-center gap-2 py-2 rounded-lg mt-4 border border-[#D5EEDB]">
          <span>⏱</span> Most customers complete the next step in under 3 minutes.
        </div>

        {/* Offer Card 1 - Muthoot */}
        <div className="bg-white rounded-[16px] p-5 mt-5 border border-[#e5e5e5] shadow-sm">
          <div className="flex justify-between items-start mb-4">
            <div>
              <div className="text-[12px] text-[#8b8b8b]">Loan Amount</div>
              <div className="text-[22px] font-bold text-[#1b1b1b]">₹8,00,000</div>
            </div>
            <div className="text-right">
              {/* Placeholder for Muthoot Logo */}
              <div className="text-[18px] font-bold text-[#002B5E] tracking-tighter">MUTHOOT</div>
            </div>
          </div>
          
          <div className="flex justify-between border-t border-[#f0f0f0] pt-4 mb-5">
            <div>
              <div className="text-[11px] text-[#8b8b8b]">EMI / Month</div>
              <div className="text-[13px] font-bold text-[#1b1b1b]">₹17,240</div>
            </div>
            <div className="text-center">
              <div className="text-[11px] text-[#8b8b8b]">Tenure</div>
              <div className="text-[13px] font-bold text-[#1b1b1b]">60 Months</div>
            </div>
            <div className="text-right">
              <div className="text-[11px] text-[#8b8b8b]">Interest</div>
              <div className="text-[13px] font-bold text-[#1b1b1b]">10.75% p.a.</div>
            </div>
          </div>

          <button 
            onClick={() => handleSelectGoldOffer("Muthoot Finance")} // 👈 Saves dynamic name
            className="w-full bg-[#B49157] text-white font-bold text-[16px] rounded-[12px] py-3 active:scale-[0.98] transition-transform"
          >
            I like this
          </button>
        </div>

        {/* Offer Card 2 - IIFL */}
        <div className="bg-white rounded-[16px] p-5 mt-4 border border-[#e5e5e5] shadow-sm">
          <div className="flex justify-between items-start mb-4">
            <div>
              <div className="text-[12px] text-[#8b8b8b]">Loan Amount</div>
              <div className="text-[22px] font-bold text-[#1b1b1b]">₹7,50,000</div>
            </div>
            <div className="text-right flex items-center gap-1">
              {/* Placeholder for IIFL Logo */}
              <span className="text-[#F37021] text-[20px]">💠</span>
              <div className="text-[16px] font-bold text-[#000000]">IIFL</div>
            </div>
          </div>
          
          <div className="flex justify-between border-t border-[#f0f0f0] pt-4 mb-5">
            <div>
              <div className="text-[11px] text-[#8b8b8b]">EMI / Month</div>
              <div className="text-[13px] font-bold text-[#1b1b1b]">₹16,820</div>
            </div>
            <div className="text-center">
              <div className="text-[11px] text-[#8b8b8b]">Tenure</div>
              <div className="text-[13px] font-bold text-[#1b1b1b]">60 Months</div>
            </div>
            <div className="text-right">
              <div className="text-[11px] text-[#8b8b8b]">Interest</div>
              <div className="text-[13px] font-bold text-[#1b1b1b]">11.00% p.a.</div>
            </div>
          </div>

          <button 
            onClick={() => handleSelectGoldOffer("IIFL Finance")} // 👈 Saves dynamic name
            className="w-full bg-[#B49157] text-white font-bold text-[16px] rounded-[12px] py-3 active:scale-[0.98] transition-transform"
          >
            I like this
          </button>
        </div>

        {/* Disclaimer */}
        <p className="text-[10px] text-[#a0a0a0] text-center mt-6 italic px-2">
          Disclaimer: These offers are subject to change at discretion of Bank / NBFC after receiving all your documents and details. Final offer will be based on risk policy of Bank / NBFC. We do not guarantee that final offer will be same as Pre-approved offer.
        </p>
      </div>
    </div>
  );
}